import { render, staticRenderFns } from "./SecurityCodeUserForm.vue?vue&type=template&id=4bc0f417"
import script from "./SecurityCodeUserForm.vue?vue&type=script&lang=js"
export * from "./SecurityCodeUserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports